import io from 'socket.io-client';
import isEqual from 'lodash/isEqual';

export default {
  data() {
    return {
      socket: io('habitica-monster-api.herokuapp.com'), // io('localhost:8082'),
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  mounted() {
    this.socket.on('EVENT_UPDATE', (data) => {
      // @TODO: Sockets shouldn't send other data
      if (data.leader !== this.user._id) return;
      // @TODO: HAcky way to push updates
      const eventIndex = this.$store.state.events.findIndex(eventItem => eventItem._id === data._id);
      const eventsWithoutItem = this.$store.state.events.filter(eventItem => eventItem._id !== data._id);

      let eventItem = this.$store.state.events[eventIndex];
      if (isEqual(eventItem, data)) return;
      eventItem = Object.assign({}, data);

      this.$store.state.events = [eventItem].concat(eventsWithoutItem);
    });

    this.socket.on('SPRITE_UPDATE', (data) => {
      // @TODO: Sockets shouldn't send other data
      if (data.userId !== this.user._id) return;
      // @TODO: HAcky way to push updates
      const eventIndex = this.$store.state.usersMonsters.findIndex(eventItem => eventItem._id === data._id);
      const eventsWithoutItem = this.$store.state.usersMonsters.filter(eventItem => eventItem._id !== data._id);

      let eventItem = this.$store.state.usersMonsters[eventIndex];
      eventItem = Object.assign({}, data);

      let { favoriteMonster } = this.$store.state;
      if (favoriteMonster._id === data._id) this.$store.state.favoriteMonster = data;

      this.$store.state.usersMonsters = [eventItem].concat(eventsWithoutItem);
    });
  },
  destroyed() {
    this.socket.off('EVENT_UPDATE');
    this.socket.off('SPRITE_UPDATE');
  },
};



// WEBPACK FOOTER //
// ./src/mixins/socketio.js